import { render } from "./headers.vue?vue&type=template&id=205f18a5&scoped=true"
const script = {}

import "./headers.vue?vue&type=style&index=0&id=205f18a5&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205f18a5"]])

export default __exports__